import React, {Component} from 'react';
import Teaser from './Components/Sections/Teaser';
import Introduction from './Components/Sections/Introduction';
import Highlight from './Components/Sections/Highlight';
import Education from './Components/Sections/Education';
import WorkExperience from './Components/Sections/WorkExperience';
import Footer from './Components/Sections/Footer';
import {CVJson} from './config';
import './App.scss';
import 'bulma/css/bulma.css';
import 'bulma-extensions/dist/css/bulma-extensions.min.css';

const CV_JSON_FILE = false;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      teaser_print: 'Constructing app component.....',
    };
    this.print = this.print.bind(this);
  }

  componentDidMount() {
    // Load json
    if (CV_JSON_FILE) {
      const jsonData = import('./cv.json');
      this.print('component mounted\nLoading cv.json data.....');
      jsonData.then(jsonData => {
        this.setState({data: jsonData});
        this.print('done\n');
        this.checkJson();
      });
    } else {
      this.print('component mounted\nLoading remote cv.json data.....');
      fetch(CVJson)
        .then(apiCall => {
          apiCall
            .json()
            .then(jsonData => {
              this.setState({data: jsonData});
              this.print('done\n');
              this.checkJson();
            })
            .catch(err => {
              this.print('error while loading json data\n');
            });
        })
        .catch(err => {
          this.print('error\n');
        });
    }
  }

  checkJson() {
    if (this.state.data.signature) {
      this.print('\n' + this.state.data.signature + '\nCopyright (c) Sanghoonjun.com. All Right Reserved\n');
      console.log(this.state.data.signature);
    }

    var str = '\nParsing Json Data...\n';
    if (this.state.data) str += 'Loading master node\n';
    for (var key in this.state.data) {
      str += 'Loading ' + key + ' node\n';
    }
    str += '\n';

    setTimeout(() => {
      this.print(str);
      this.animateLoading(0);
    }, 700);
  }

  print(str) {
    this.setState({teaser_print: this.state.teaser_print + str});
  }

  animateLoading(step) {
    switch (step) {
      case 0:
        setTimeout(() => {
          this.print('Page was successfully rendered, ready to use\n');
          this.animateLoading(1);
        }, 700);
        break;
      case 1:
        setTimeout(() => {
          this.print('\nHello World!');
          this.animateLoading(2);
        }, 1100);
        break;
      case 2:
        setTimeout(() => {
          this.print(`\nI'm ${this.state.data.introduction.name}.\n`);
          this.animateLoading(3);
        }, 200);
        break;
      case 3:
        setTimeout(() => {
          this.print('\nHit ENTER for the details (or SCROLL DOWN 😄)');
          this.animateLoading(4);
        }, 300);
        break;
      default:
        break;
    }
  }
  render() {
    if (!this.state.data) {
      return (
        <div className="app-wrapper">
          <Teaser print={this.state.teaser_print} />
        </div>
      );
    }
    return (
      <div className="app-wrapper">
        {/*
        <Teaser
          data={this.state.data.introduction}
          print={this.state.teaser_print}
          onKeyPress={e => {
            if (e.key === 'Enter')
              window.scrollTo({
                left: 0,
                top: this.refs.start.offsetTop,
                behavior: 'smooth',
              });
          }}
        />
        <div ref="start" />
        */}
        <Introduction data={this.state.data.introduction} />
        <Highlight data={this.state.data.highlight} />
        <WorkExperience data={this.state.data.work_experience} />
        <Education data={this.state.data.education} />
        <Footer />
      </div>
    );
  }
}
export default App;
